
export const expiringCertifications = () => {
  return new Promise(resolve => {
    let $certGrid = $('.js-sitedocs-certification-grid');
    if ($certGrid.length) {
      $certGrid = $certGrid.kendoGrid({
        columns: [
          {
            field: 'CertificationName',
            title: 'Certification',
            type: 'string',
            headerAttributes: {style: 'white-space: normal'}
          },
          {
            field: 'Acquired',
            title: 'Acquired',
            type: 'date', 
            format: '{0: M/d/yyyy}',
            headerAttributes: {style: 'white-space: normal'}
          },
          {
            field: 'Expires',
            title: 'Expiration Date',
            type: 'date',
            format: '{0: M/d/yyyy}',
            headerAttributes: {style: 'white-space: normal'}
          }
        ],
        dataSource: {
          schema: { Id: "CertificationName" },
          transport: {
            read: {
              url: '/SiteDocs/ExpiringCertifications',
              type: 'POST',
              dataType: 'json'
            }
          },
          sort: {
            dir: 'asc',
            field: 'Expires'
          }
        },
        resizable: false,
        mobile: true,
        scrollable: true,
        sortable: true,
        filterable: false,
        dataBound(e) {
          let that = this;
          let data = e.sender.element.find('tbody tr');
          $.each(data, function (i, row) {
            let isExpired = that.dataItem(row).IsExpired;
            if (isExpired) {
              $(row).children('td').wrapInner(() => '<span class="grid-cell--status --danger"></span>');
            }
          });
        }
      }).data('kendoGrid');
      
      resolve();
    }else{
      resolve();
    }
  });
};